module.exports = __webpack_public_path__ + "img/Trackers@4x.663542ac.png";